import { action, makeObservable, observable } from 'mobx';

import { RouteUrlBuilder } from '../../../app/RouteDefinitions';
import { ModalState } from '../../../app/shared/ModalState';
import { INavigationService } from '../../../app/shared/NavigationService';
import { StoreUrlBuilder } from '../../../app/shared/StoreUrlBuilder';
import { AddedToCartModalTranslation } from '../../localization/SiteTranslation';
import RouteDefinitions from '../../routing/RouteDefinitions';

export class AddedToCartModalState<T> extends ModalState {
  @observable.ref
  public recentlyAddedItem?: T;

  @observable
  public recentlyAddedQuantity?: number;

  constructor(
    private navigation: INavigationService,
    public translation: AddedToCartModalTranslation,
  ) {
    super();
    makeObservable(this);
  }

  @action.bound
  public setRecentlyAddedItem(item: T, addedQuantity: number) {
    this.recentlyAddedItem = item;
    this.recentlyAddedQuantity = addedQuantity;
  }

  public goToCart = async () => {
    this.close();
    this.navigation.navigateTo(StoreUrlBuilder.withContext(RouteUrlBuilder.getUrlTo(RouteDefinitions.cartRoute)));
  };
}
